module.exports = __webpack_public_path__ + "img/2.b06c6b34.png";